<!-- Mobile Top Bar (only visible on mobile) -->
@if (isMobile()) {
<mat-toolbar class="mobile-top-bar">
  <button mat-icon-button (click)="toggleMenu()" class="menu-toggle-btn" [attr.aria-label]="'Abrir menú' | translate">
    <mat-icon class="mobile-menu-icon">menu</mat-icon>
  </button>
  <span class="spacer"></span>
  <img class="logo" src="assets/logos/Logo_Sidney.png" [alt]="'Sidney Logo' | translate">
</mat-toolbar>
}

<!-- Mobile Drawer Backdrop -->
@if (isMobile() && menuOpen()) {
<div class="mobile-drawer-backdrop" (click)="toggleMenu()"></div>
}

<!-- Navigation Drawer / Rail Container -->
<div class="drawer-container" [class.is-rail]="isRail()" [class.mobile-open]="isMobile() && menuOpen()">

  <header>
    <button (click)="toggleMenu()" class="menu-toggle-btn filled"
      [attr.aria-label]="(isRail() ? 'Abrir menú' : 'Cerrar menú') | translate">
      <mat-icon>
        {{ isMobile() ? 'menu_open' : (isRail() ? 'menu' : 'menu_open') }}
      </mat-icon>
    </button>

    @if (isRail()) {
    <button class="menu-create-btn filled" routerLink="/trips/createtrip" [attr.aria-label]="'Crear viaje' | translate">
      <mat-icon>add</mat-icon>
    </button>
    } @else {
    <img class="logo" src="assets/logos/Logo_Sidney.png" [alt]="'Sidney Logo' | translate">
    }
  </header>

  @if (!isRail()) {
  <div class="create-btn-container">
    <button mat-flat-button class="create-btn label-large" routerLink="/trips/createtrip"
      (click)="isMobile() && toggleMenu()" [attr.aria-label]="'Crear Viaje' | translate">
      <mat-icon>add</mat-icon>
      <span class="btn-text">{{ 'Crear Viaje' | translate }}</span>
    </button>
  </div>
  }

  <div class="header-divider"></div>

  <div class="scroll-content">
    <mat-nav-list class="main-nav">
      <!-- Panel principal -->
      <a mat-list-item routerLink="/dashboard" routerLinkActive="active-link" class="nav-item"
        (click)="isMobile() && toggleMenu()">
        <mat-icon matListItemIcon>space_dashboard</mat-icon>
        <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Panel principal' | translate }}</span>
      </a>

      <!-- Operación en vivo -->
      <a mat-list-item routerLink="/livemap" routerLinkActive="active-link" class="nav-item"
        (click)="isMobile() && toggleMenu()">
        <mat-icon matListItemIcon>map</mat-icon>
        <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Operación en vivo' | translate }}</span>
      </a>

      <!-- Viajes -->
      <a mat-list-item routerLink="/trips" routerLinkActive="active-link" class="nav-item"
        (click)="isMobile() && toggleMenu()">
        <mat-icon matListItemIcon>route</mat-icon>
        <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Viajes' | translate }}</span>
      </a>

      <!-- Red logística (Expandable) — administrator only, see section-permissions.model -->
      @if (canSee('logistics')) {
      <mat-expansion-panel [class.rail-panel]="isRail()" flat class="nav-expansion" [expanded]="logisticsExpanded()"
        (expandedChange)="logisticsExpanded.set($event)" hideToggle>
        <mat-expansion-panel-header (click)="handlePanelClick('logistics', $event)">
          <mat-panel-title>
            <mat-icon>emoji_transportation</mat-icon>
            <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Red logística' | translate }}</span>
            @if (!isRail()) {
            <mat-icon class="panel-arrow" [class.rotated]="logisticsExpanded()">keyboard_arrow_right</mat-icon>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list class="sub-nav">
          <a mat-list-item routerLink="/locations" routerLinkActive="active-link" (click)="isMobile() && toggleMenu()">
            <mat-icon matListItemIcon>location_on</mat-icon>
            <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Locaciones' | translate }}</span>
          </a>
          <a mat-list-item routerLink="/vehicles" routerLinkActive="active-link" (click)="isMobile() && toggleMenu()">
            <mat-icon matListItemIcon>directions_car</mat-icon>
            <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Vehículos' | translate }}</span>
          </a>
        </mat-nav-list>
      </mat-expansion-panel>
      }

      <!-- Fuerza de trabajo (Expandable) — administrator only -->
      @if (canSee('workforce')) {
      <mat-expansion-panel [class.rail-panel]="isRail()" flat class="nav-expansion" [expanded]="workforceExpanded()"
        (expandedChange)="workforceExpanded.set($event)" hideToggle>
        <mat-expansion-panel-header (click)="handlePanelClick('workforce', $event)">
          <mat-panel-title>
            <mat-icon>engineering</mat-icon>
            <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Fuerza de trabajo' | translate
              }}</span>
            @if (!isRail()) {
            <mat-icon class="panel-arrow" [class.rotated]="workforceExpanded()">keyboard_arrow_right</mat-icon>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list class="sub-nav">
          <a mat-list-item routerLink="/drivers" routerLinkActive="active-link" (click)="isMobile() && toggleMenu()">
            <mat-icon matListItemIcon>badge</mat-icon>
            <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Conductores' | translate }}</span>
          </a>
          <a mat-list-item routerLink="/managers" routerLinkActive="active-link" (click)="isMobile() && toggleMenu()">
            <mat-icon matListItemIcon>assignment_ind</mat-icon>
            <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Gestores' | translate }}</span>
          </a>
        </mat-nav-list>
      </mat-expansion-panel>
      }

      <!-- Clientes (Expandable) — administrator only -->
      @if (canSee('clients')) {
      <mat-expansion-panel [class.rail-panel]="isRail()" flat class="nav-expansion" [expanded]="clientsExpanded()"
        (expandedChange)="clientsExpanded.set($event)" hideToggle>
        <mat-expansion-panel-header (click)="handlePanelClick('clients', $event)">
          <mat-panel-title>
            <mat-icon>group</mat-icon>
            <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Clientes' | translate }}</span>
            @if (!isRail()) {
            <mat-icon class="panel-arrow" [class.rotated]="clientsExpanded()">keyboard_arrow_right</mat-icon>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list class="sub-nav">
          <a mat-list-item routerLink="/contracts" routerLinkActive="active-link" (click)="isMobile() && toggleMenu()">
            <mat-icon matListItemIcon>article</mat-icon>
            <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Contratos' | translate }}</span>
          </a>
          <a mat-list-item routerLink="/users" routerLinkActive="active-link" (click)="isMobile() && toggleMenu()">
            <mat-icon matListItemIcon>contacts</mat-icon>
            <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Usuarios' | translate }}</span>
          </a>
        </mat-nav-list>
      </mat-expansion-panel>
      }

      <!-- Reportes (Expandable) -->
      <mat-expansion-panel [class.rail-panel]="isRail()" flat class="nav-expansion" [expanded]="reportsExpanded()"
        (expandedChange)="reportsExpanded.set($event)" hideToggle>
        <mat-expansion-panel-header (click)="handlePanelClick('reports', $event)">
          <mat-panel-title>
            <mat-icon>bar_chart</mat-icon>
            <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Reportes' | translate }}</span>
            @if (!isRail()) {
            <mat-icon class="panel-arrow" [class.rotated]="reportsExpanded()">keyboard_arrow_right</mat-icon>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list class="sub-nav">
          <a mat-list-item routerLink="/reports/trips" routerLinkActive="active-link"
            (click)="isMobile() && toggleMenu()">
            <mat-icon matListItemIcon>route</mat-icon>
            <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Viajes' | translate }}</span>
          </a>
          @if (canSee('driverReports')) {
          <a mat-list-item routerLink="/reports/drivers" routerLinkActive="active-link"
            (click)="isMobile() && toggleMenu()">
            <mat-icon matListItemIcon>badge</mat-icon>
            <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Conductores' | translate }}</span>
          </a>
          }
          @if (canSee('auditReports')) {
          <a mat-list-item routerLink="/reports/audit" routerLinkActive="active-link"
            (click)="isMobile() && toggleMenu()">
            <mat-icon matListItemIcon>history</mat-icon>
            <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Historial de cambios' | translate
              }}</span>
          </a>
          }
          <a mat-list-item routerLink="/reports/custom" routerLinkActive="active-link"
            (click)="isMobile() && toggleMenu()">
            <mat-icon matListItemIcon>dashboard_customize</mat-icon>
            <span class="nav-label anim-label" [class.rail-hidden]="isRail()">{{ 'Personalizado' | translate }}</span>
          </a>
        </mat-nav-list>
      </mat-expansion-panel>

      <!-- Soluciones (Productos) -->
      @if (!isRail()) {
      <mat-divider class="sub-divider header-divider"></mat-divider>
      <a mat-list-item class="nav-item" (click)="openSwitchSolutionModal()">
        <mat-icon matListItemIcon>apps</mat-icon>
        <span class="nav-label anim-label">{{ 'Soluciones' | translate }}</span>
      </a>
      }
    </mat-nav-list>
  </div>

  <footer>
    @if (isRail()) {
    <a mat-list-item class="nav-item" (click)="openSwitchSolutionModal()" [attr.aria-label]="'Soluciones' | translate">
      <mat-icon matListItemIcon>apps</mat-icon>
    </a>
    }

    <div class="user-profile" [matMenuTriggerFor]="userMenu">
      <div class="user-avatar-container">
        <div class="user-avatar">
          <img [src]="avatarUrl()" (error)="onAvatarError($event)" [alt]="'User Profile' | translate"
            class="avatar-img">
        </div>
      </div>
      <div class="user-info anim-content" [class.rail-hidden]="isRail()">
        <span class="user-name">{{ userName() }}</span>
        <span class="user-role">{{ userRole() }}</span>
      </div>
      <mat-icon class="arrow-icon anim-content" [class.rail-hidden]="isRail()">keyboard_arrow_right</mat-icon>
    </div>
  </footer>

</div>

<mat-menu #userMenu="matMenu" xPosition="after" yPosition="above" class="user-dropdown-menu">
  <a mat-menu-item routerLink="/settings">
    <mat-icon>account_circle</mat-icon>
    <span>{{ 'Perfil' | translate }}</span>
  </a>
  @if (canSwitchWorkspace()) {
  <button mat-menu-item (click)="openSwitchWorkspaceModal()">
    <mat-icon>swap_horiz</mat-icon>
    <span>{{ 'Cambiar de workspace' | translate }}</span>
  </button>
  }
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>{{ 'Cerrar sesión' | translate }}</span>
  </button>
</mat-menu>